'use strict';

import slicks from './../common/slicks';

export default function objectSlider () {
    let $slider = $('.js-object-slider');

    if (!$slider.length) {
        return;
    }

    slicks($slider, {
        dots: true,
        slidesToShow: 1,
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: false
            }
        }]
    });
}
